export enum DeBounceTimer {
  SEARCH_DELAY = 1500,
  RANGE_DELAY = 2000,
}
